import React from 'react';
import { EuiPageBody, EuiPageBodyProps } from '@elastic/eui';

export default (props: EuiPageBodyProps) => (
  <EuiPageBody {...props} data-testid="TectonPage__Body">
    {props.children}
  </EuiPageBody>
);
